module.exports = __webpack_public_path__ + "static/20-Technicolor-4a47fea05d630e37dd806405ff713b43.png";